import { Component, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';


@Component({
  selector: 'app-preview-login-content',
  imports: [],
  templateUrl: './preview-login-content.component.html',
  styleUrl: './preview-login-content.component.scss'
})
export class PreviewLoginContentComponent {

  @Input() public Content: any;
  textContent: string = '';

  constructor(
    public modalRef: NgbActiveModal,
  ) { }

  ngOnInit()
  {
    
    this.textContent = this.Content?.content?.textContent??"";
   
  }

}
